export default class Coupon {
  readonly code: string;
  readonly id: string;
  readonly isApplicable: boolean;
  readonly title: string;

  constructor(data: { [key: string]: any }) {
    this.code = data.code;
    this.id = data.id;
    this.isApplicable = data.is_applicable;
    this.title = data.title;
  }
}

